import { EventStatus as AmbassadorEventStatus, EventType as AmbassadorEventType, LocationType as AmbassadorLocationType, RegistrationStatus as AmbassadorRegistrationStatus, RsvpStatusOptions as AmbassadorRsvpStatusOptions, Status as AmbassadorStatus, TaxType as AmbassadorTaxType, } from '@wix/ambassador-wix-events-web/types';
import { EventStatus, EventType, LocationType, RegistrationStatus, RsvpStatusOptions, Status, TaxType, VisitorType, } from '@wix/events-types';
import { getFormattedMoney } from '../price';
export var getEventId = function (event) { return event.id; };
export var getSlug = function (event) { return event.slug; };
export var getEventTitle = function (event) { return event.title; };
export var getEventTicketLimitPerOrder = function (event) { var _a; return (_a = event.registration.ticketing.config) === null || _a === void 0 ? void 0 : _a.ticketLimitPerOrder; };
export var getEventMainImage = function (event) { return event.mainImage; };
export var getEventDescription = function (event) { return event.description; };
export var getRegistrationStatus = function (event) { return event.registration.status; };
export var getAboutText = function (event) {
    return event.about && event.about !== '<p></p>' ? event.about : '';
};
export var isEndDateHidden = function (event) { return event.scheduling.config.endDateHidden; };
export var isTicketed = function (event) {
    return event.registration.type === EventType.TICKETS || event.registration.type === AmbassadorEventType.TICKETS;
};
export var isInitiallyTicketed = function (event) {
    return event.registration.initialType === EventType.TICKETS || event.registration.initialType === AmbassadorEventType.TICKETS;
};
export var ticketedOrInitiallyTicketed = function (event) {
    return isTicketed(event) || isInitiallyTicketed(event);
};
export var isInitiallyRsvp = function (event) {
    return event.registration.initialType === EventType.RSVP || event.registration.initialType === AmbassadorEventType.RSVP;
};
export var isRsvp = function (event) {
    return event.registration.type === EventType.RSVP || event.registration.initialType === AmbassadorEventType.RSVP;
};
export var rsvpOrInitiallyRsvp = function (event) { return isRsvp(event) || isInitiallyRsvp(event); };
export var isRegistrationClosed = function (event) {
    return isRegistrationAutomaticallyClosed(event) || isRegistrationManuallyClosed(event);
};
export var isScheduled = function (event) {
    return event.status === EventStatus.SCHEDULED || event.status === AmbassadorEventStatus.SCHEDULED;
};
export var isStarted = function (event) {
    return event.status === EventStatus.STARTED || event.status === AmbassadorEventStatus.STARTED;
};
export var isEnded = function (event) {
    return event.status === EventStatus.ENDED || event.status === AmbassadorEventStatus.ENDED;
};
export var isCanceled = function (event) {
    return event.status === EventStatus.CANCELED || event.status === AmbassadorEventStatus.CANCELED;
};
export var isDraft = function (event) {
    return event.status === EventStatus.DRAFT || event.status === AmbassadorEventStatus.DRAFT;
};
export var isPastOrCanceled = function (event) { return isEnded(event) || isCanceled(event); };
export var isActive = function (event) { return !isEnded(event) && !isCanceled(event); };
export var isRegistrationAutomaticallyClosed = function (event) {
    return event.registration.status === RegistrationStatus.CLOSED ||
        event.registration.status === AmbassadorRegistrationStatus.CLOSED;
};
export var isRegistrationManuallyClosed = function (event) {
    return (event.registration.status === RegistrationStatus.CLOSED_MANUALLY ||
        event.registration.status === AmbassadorRegistrationStatus.CLOSED_MANUALLY) &&
        !isExternal(event);
};
export var isRegistrationExternal = function (event) {
    return event.registration.status === RegistrationStatus.OPEN_EXTERNAL ||
        event.registration.status === AmbassadorRegistrationStatus.OPEN_EXTERNAL;
};
export var isWithoutRegistration = function (event) {
    return event.registration.type === EventType.NO_REGISTRATION ||
        event.registration.type === AmbassadorEventType.NO_REGISTRATION;
};
export var isExternal = function (event) {
    return event.registration.type === EventType.EXTERNAL || event.registration.type === AmbassadorEventType.EXTERNAL;
};
export var isInternal = function (event) {
    return isRsvp(event) || isTicketed(event) || (!event.id && !isExternal(event));
};
export var isWaitlistOpen = function (event) {
    return event.registration.status === RegistrationStatus.OPEN_RSVP_WAITLIST ||
        event.registration.status === AmbassadorRegistrationStatus.OPEN_RSVP_WAITLIST;
};
export var isWaitlistEnabled = function (event) { var _a; return (_a = event.registration.rsvpCollection) === null || _a === void 0 ? void 0 : _a.config.waitlist; };
export var isDateTbd = function (event) { return event.scheduling.config.scheduleTbd; };
export var isEmpty = function (event) {
    return ticketedOrInitiallyTicketed(event) ? !(event === null || event === void 0 ? void 0 : event.dashboard.ticketingSummary.tickets) : !(event === null || event === void 0 ? void 0 : event.dashboard.rsvpSummary.total);
};
export var isFull = function (event) {
    return isScheduled(event) && (isRegistrationAutomaticallyClosed(event) || isWaitlistOpen(event));
};
export var isSoldOut = function (event) { var _a; return isTicketed(event) && ((_a = event.registration.ticketing) === null || _a === void 0 ? void 0 : _a.soldOut); };
export var isPaid = function (event) { return Boolean(event.registration.ticketing.highestPrice); };
export var isFree = function (event) { return !isPaid(event); };
export var isWithDefaultForm = function (event) { return event.form.controls.length === 2; };
export var isLocationTbd = function (event) {
    return !isEventLocationOnline(event) && !event.location.address;
};
export var isEventLocationOnline = function (event) {
    var _a, _b;
    return ((_a = event.location.type) !== null && _a !== void 0 ? _a : LocationType.VENUE) === LocationType.ONLINE ||
        ((_b = event.location.type) !== null && _b !== void 0 ? _b : AmbassadorLocationType.VENUE) === AmbassadorLocationType.ONLINE;
};
export var getFormattedLocation = function (event) {
    return event.location.name || event.location.address;
};
export var getFormattedFullLocation = function (event) {
    if (event.location.address && event.location.name) {
        return event.location.name + ", " + event.location.address;
    }
    return getFormattedLocation(event);
};
export var getCoordinates = function (event) { return event.location.coordinates; };
export var getOrdersCount = function (_a) {
    var _b, _c;
    var dashboard = _a.dashboard;
    return (_c = (_b = dashboard === null || dashboard === void 0 ? void 0 : dashboard.ticketingSummary) === null || _b === void 0 ? void 0 : _b.orders) !== null && _c !== void 0 ? _c : 0;
};
export var getRSVPCount = function (_a) {
    var _b, _c;
    var dashboard = _a.dashboard;
    return (_c = (_b = dashboard === null || dashboard === void 0 ? void 0 : dashboard.rsvpSummary) === null || _b === void 0 ? void 0 : _b.total) !== null && _c !== void 0 ? _c : 0;
};
export var hasRSVPs = function (event) { return !!getRSVPCount(event); };
export var getTicketsCount = function (_a) {
    var _b, _c;
    var dashboard = _a.dashboard;
    return (_c = (_b = dashboard === null || dashboard === void 0 ? void 0 : dashboard.ticketingSummary) === null || _b === void 0 ? void 0 : _b.tickets) !== null && _c !== void 0 ? _c : 0;
};
export var hasTickets = function (event) { return !!getTicketsCount(event); };
export var hasOrders = function (event) { return Boolean(getOrdersCount(event)); };
export var getTotalGuests = function (event) {
    var ticketed = ticketedOrInitiallyTicketed(event);
    var initiallyRsvpOrTicketed = isInitiallyTicketed(event) || isInitiallyRsvp(event);
    var internal = isInternal(event);
    if (!internal && !initiallyRsvpOrTicketed) {
        return 0;
    }
    return ticketed ? getTicketsCount(event) : getRSVPCount(event);
};
export var hasImage = function (event) { var _a; return !!((_a = event.mainImage) === null || _a === void 0 ? void 0 : _a.id); };
export var getRestrictedTo = function (event) { var _a; return (_a = event.registration.restrictedTo) !== null && _a !== void 0 ? _a : VisitorType.VISITOR; };
export var getExternalLink = function (event) { var _a, _b; return (_b = (_a = event.registration.external) === null || _a === void 0 ? void 0 : _a.registration) !== null && _b !== void 0 ? _b : null; };
export var getGuestLimit = function (event) { var _a, _b; return (_b = (_a = event.registration.rsvpCollection) === null || _a === void 0 ? void 0 : _a.config.limit) !== null && _b !== void 0 ? _b : null; };
export var getRsvpStatus = function (event) { var _a; return (_a = event.registration.rsvpCollection) === null || _a === void 0 ? void 0 : _a.config.rsvpStatusOptions; };
export var getCurrency = function (event) { return event.registration.ticketing.currency; };
export var isCurrencySet = function (event) { return !!getCurrency(event); };
export var isCurrencyLocked = function (event) { var _a, _b; return (_b = (_a = event.dashboard) === null || _a === void 0 ? void 0 : _a.ticketingSummary.currencyLocked) !== null && _b !== void 0 ? _b : true; };
export var isAssignedTickets = function (event) { var _a, _b, _c; return !!((_c = (_b = (_a = event.registration) === null || _a === void 0 ? void 0 : _a.ticketing) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.guestAssignedTickets); };
export var getTaxConfig = function (event) { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = event.registration) === null || _a === void 0 ? void 0 : _a.ticketing) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.taxConfig) !== null && _d !== void 0 ? _d : null; };
export var isTaxIncluded = function (event) {
    var _a, _b, _c, _d, _e, _f;
    return ((_c = (_b = (_a = event.registration) === null || _a === void 0 ? void 0 : _a.ticketing) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.taxConfig.type) === TaxType.INCLUDED ||
        ((_f = (_e = (_d = event.registration) === null || _d === void 0 ? void 0 : _d.ticketing) === null || _e === void 0 ? void 0 : _e.config) === null || _f === void 0 ? void 0 : _f.taxConfig.type) === AmbassadorTaxType.INCLUDED;
};
export var isNoResponseEnabled = function (event) {
    var _a, _b;
    return ((_a = event.registration.rsvpCollection) === null || _a === void 0 ? void 0 : _a.config.rsvpStatusOptions) === RsvpStatusOptions.YES_AND_NO ||
        ((_b = event.registration.rsvpCollection) === null || _b === void 0 ? void 0 : _b.config.rsvpStatusOptions) === AmbassadorRsvpStatusOptions.YES_AND_NO;
};
export var getRsvpStatusOptions = function (event) { var _a; return (_a = event.registration.rsvpCollection) === null || _a === void 0 ? void 0 : _a.config.rsvpStatusOptions; };
export var getFormControls = function (event) { return event.form.controls; };
export var getFormMessages = function (event) { return event.form.messages; };
export var isOnlineConferencingEnabled = function (event) { var _a, _b, _c; return (_c = (_b = (_a = event.onlineConferencing) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.enabled) !== null && _c !== void 0 ? _c : false; };
export var getOnlineConferencingProviderId = function (event) { var _a, _b, _c; return (_c = (_b = (_a = event.onlineConferencing) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.providerId) !== null && _c !== void 0 ? _c : ''; };
export var getOnlineConferencingType = function (event) { var _a, _b; return (_b = (_a = event.onlineConferencing) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.conferenceType; };
export var getOnlineConferencingGuestUrl = function (event) { var _a, _b, _c; return (_c = (_b = (_a = event.onlineConferencing) === null || _a === void 0 ? void 0 : _a.session) === null || _b === void 0 ? void 0 : _b.guestLink) !== null && _c !== void 0 ? _c : ''; };
export var getOnlineConferencingHostUrl = function (event) { var _a, _b, _c; return (_c = (_b = (_a = event.onlineConferencing) === null || _a === void 0 ? void 0 : _a.session) === null || _b === void 0 ? void 0 : _b.hostLink) !== null && _c !== void 0 ? _c : ''; };
export var getOnlineConferencingPassword = function (event) { var _a, _b, _c; return (_c = (_b = (_a = event.onlineConferencing) === null || _a === void 0 ? void 0 : _a.session) === null || _b === void 0 ? void 0 : _b.password) !== null && _c !== void 0 ? _c : ''; };
export var getEventPageUrl = function (event) {
    var _a = event.eventPageUrl, base = _a.base, path = _a.path;
    return "" + base + path.split('?')[0];
};
export var getTimeZoneId = function (event) {
    return (!isDateTbd(event) && event.scheduling.config.timeZoneId) || 'UTC';
};
export var getShowTimeZone = function (event) { return event.scheduling.config.showTimeZone; };
export var getStartDate = function (event) { return event.scheduling.config.startDate; };
export var getEndDate = function (event) { return event.scheduling.config.endDate; };
export var getOccurrences = function (event) { var _a, _b; return (_b = (_a = event.scheduling.config.recurrences) === null || _a === void 0 ? void 0 : _a.occurrences) !== null && _b !== void 0 ? _b : []; };
export var hasOccurrences = function (event) { return Boolean(getOccurrences(event).length); };
export var isOneTimeEvent = function (event) {
    return getRecurrenceStatus(event) === Status.ONE_TIME || getRecurrenceStatus(event) === AmbassadorStatus.ONE_TIME;
};
export var isRecurringEvent = function (event) {
    return getRecurrenceStatus(event) === Status.RECURRING ||
        getRecurrenceStatus(event) === AmbassadorStatus.RECURRING ||
        isRecurringNextEvent(event) ||
        isRecurringLastEndedEvent(event) ||
        isRecurringLastCanceledEvent(event);
};
export var isRecurringNextEvent = function (event) {
    return getRecurrenceStatus(event) === Status.RECURRING_NEXT || getRecurrenceStatus(event) === AmbassadorStatus.RECURRING_NEXT;
};
export var isRecurringLastEndedEvent = function (event) {
    return getRecurrenceStatus(event) === Status.RECURRING_LAST_ENDED ||
        getRecurrenceStatus(event) === AmbassadorStatus.RECURRING_LAST_ENDED;
};
export var isRecurringLastCanceledEvent = function (event) {
    return getRecurrenceStatus(event) === Status.RECURRING_LAST_CANCELED ||
        getRecurrenceStatus(event) === AmbassadorStatus.RECURRING_LAST_CANCELED;
};
export var getRecurrenceStatus = function (event) { var _a, _b; return (_b = (_a = event.scheduling.config.recurrences) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : Status.ONE_TIME; };
export var getRecurrenceCategoryId = function (event) { var _a; return (_a = event.scheduling.config.recurrences) === null || _a === void 0 ? void 0 : _a.categoryId; };
export var getTicketsPriceRange = function (event) {
    if (isTicketed(event) && hasTicketDefinitions(event)) {
        var _a = event.registration.ticketing, lowestTicketPriceFormatted = _a.lowestTicketPriceFormatted, highestTicketPriceFormatted = _a.highestTicketPriceFormatted;
        if (lowestTicketPriceFormatted === highestTicketPriceFormatted) {
            return lowestTicketPriceFormatted;
        }
        return lowestTicketPriceFormatted + " - " + highestTicketPriceFormatted;
    }
    return undefined;
};
export var hasTicketDefinitions = function (event) { var _a; return ((_a = event.registration.ticketing) === null || _a === void 0 ? void 0 : _a.lowestPrice) !== undefined; };
export var wasTicketed = function (event) {
    return event.registration.type !== EventType.RSVP &&
        (hasTicketDefinitions(event) || !!event.dashboard.ticketingSummary.tickets);
};
export var getTotalSales = function (event, fallbackCurrency) {
    return ticketedOrInitiallyTicketed(event) &&
        (event.dashboard.ticketingSummary.totalSales
            ? getFormattedMoney(event.dashboard.ticketingSummary.totalSales)
            : getFormattedMoney({ amount: '0', currency: getCurrency(event) || fallbackCurrency }));
};
export var getWaitlistedAttendees = function (event) { var _a; return (_a = event.dashboard.rsvpSummary) === null || _a === void 0 ? void 0 : _a.waitlist; };
export var hasOnlineConferencingProvider = function (event) {
    return Boolean(getOnlineConferencingProviderId(event));
};
export var isRegistrationClosedVisible = function (event) {
    if (isDraft(event)) {
        return new Date(getEndDate(event)) < new Date();
    }
    return isRegistrationClosed(event);
};
export var isPersonalAgendaEnabled = function (event) { var _a, _b; return (_b = (_a = event === null || event === void 0 ? void 0 : event.agenda) === null || _a === void 0 ? void 0 : _a.enabled) !== null && _b !== void 0 ? _b : false; };
//# sourceMappingURL=event.js.map